var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.862 18.812l-5.038-5.04a.463.463 0 00-.332-.136h-.403A8.123 8.123 0 008.124 0 8.123 8.123 0 000 8.125a8.123 8.123 0 0013.636 5.968v.399c0 .124.05.242.137.331l5.039 5.04a.47.47 0 00.664 0l.386-.387a.47.47 0 000-.664zM8.125 14.999A6.87 6.87 0 011.25 8.125 6.87 6.87 0 018.125 1.25a6.87 6.87 0 016.874 6.875 6.87 6.87 0 01-6.874 6.874z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchYellow);
export default __webpack_public_path__ + "static/media/search-yellow.f3b6e3b3231696e27081b0fea0779966.svg";
export { ForwardRef as ReactComponent };